var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureTab2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 46,
    viewBox: "0 0 33 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1202_168)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1202_168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 2.16476V40.2656C33 41.0186 32.8519 41.7643 32.5642 42.4601C32.2765 43.1558 31.8548 43.7879 31.3231 44.3204C30.7915 44.8529 30.1603 45.2753 29.4657 45.5635C28.7711 45.8517 28.0266 46 27.2748 46H5.73176C4.21273 46 2.75583 45.3961 1.6811 44.3208C0.606378 43.2456 0.00173074 41.7871 6.45906e-07 40.2656V18.688C0.00172848 17.1659 0.606166 15.7067 1.6807 14.6304C2.75524 13.5542 4.21213 12.9488 5.73176 12.947H20.7923L29.0505 0.93549C29.313 0.555448 29.6899 0.269265 30.1261 0.118595C30.5623 -0.0320746 31.0352 -0.0393656 31.4758 0.097783C31.9165 0.234932 32.3019 0.509363 32.5761 0.881129C32.8502 1.2529 32.9987 1.70259 33 2.16476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 2.16476V40.2656C33 41.0186 32.8519 41.7643 32.5642 42.4601C32.2765 43.1558 31.8548 43.7879 31.3231 44.3204C30.7915 44.8529 30.1603 45.2753 29.4657 45.5635C28.7711 45.8517 28.0266 46 27.2748 46H5.73176C4.21273 46 2.75583 45.3961 1.6811 44.3208C0.606378 43.2456 0.00173074 41.7871 6.45906e-07 40.2656V18.688C0.00172848 17.1659 0.606166 15.7067 1.6807 14.6304C2.75524 13.5542 4.21213 12.9488 5.73176 12.947H20.7923L29.0505 0.93549C29.313 0.555448 29.6899 0.269265 30.1261 0.118595C30.5623 -0.0320746 31.0352 -0.0393656 31.4758 0.097783C31.9165 0.234932 32.3019 0.509363 32.5761 0.881129C32.8502 1.2529 32.9987 1.70259 33 2.16476Z",
    fill: "url(#paint0_linear_1202_168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 2.16476V40.2656C33 41.0186 32.8519 41.7643 32.5642 42.4601C32.2765 43.1558 31.8548 43.7879 31.3231 44.3204C30.7915 44.8529 30.1603 45.2753 29.4657 45.5635C28.7711 45.8517 28.0266 46 27.2748 46H5.73176C4.21273 46 2.75583 45.3961 1.6811 44.3208C0.606378 43.2456 0.00173074 41.7871 6.45906e-07 40.2656V18.688C0.00172848 17.1659 0.606166 15.7067 1.6807 14.6304C2.75524 13.5542 4.21213 12.9488 5.73176 12.947H20.7923L29.0505 0.93549C29.313 0.555448 29.6899 0.269265 30.1261 0.118595C30.5623 -0.0320746 31.0352 -0.0393656 31.4758 0.097783C31.9165 0.234932 32.3019 0.509363 32.5761 0.881129C32.8502 1.2529 32.9987 1.70259 33 2.16476Z",
    fill: "url(#paint1_linear_1202_168)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 20.1166C12.7617 20.4994 10.2969 22.2728 8.97266 24.9955C8.73047 25.4955 8.49219 26.0697 8.38672 26.4095L8.36328 26.4994H10.1328H11.9023L13.0312 24.2142C13.6523 22.9564 14.1719 21.9408 14.1875 21.9564C14.1992 21.9759 14.7109 23.0033 15.3242 24.2416L16.4336 26.4994L17.7227 26.5033C18.4336 26.5072 19.5898 26.5228 20.2969 26.5345L21.582 26.558L19.75 28.6986C18.7422 29.8783 17.9141 30.8783 17.9062 30.9252C17.9023 30.972 18.082 32.0892 18.3086 33.4095C18.5352 34.7299 18.7109 35.8158 18.6992 35.8275C18.6797 35.847 14.0742 34.1634 14.0195 34.1166C13.9961 34.0931 14.3516 33.0424 14.3984 32.9955C14.4023 32.9877 15.0234 33.2103 15.7734 33.4877C17.0586 33.9642 17.1367 33.9877 17.1484 33.9095C17.1523 33.8627 17.0273 33.0853 16.8711 32.183L16.5859 30.5424L17.7734 29.1556L18.9609 27.7689L18.8125 27.7416C18.7266 27.7259 17.9922 27.7142 17.1719 27.7142L15.6836 27.7103L14.9336 26.1869C14.5234 25.347 14.1719 24.6674 14.1562 24.6791C14.1367 24.6908 13.793 25.3744 13.3828 26.2025L12.6445 27.7103H10.6094C9.48828 27.7103 8.46875 27.722 8.33594 27.7338C8.10937 27.7572 8.10156 27.765 8.07812 27.8822C8.06641 27.9486 8.04297 28.3431 8.03125 28.7533L8.00391 29.5072H10.3164H12.625V30.1127V30.7181H10.3984H8.17187L8.19531 30.8236C8.3125 31.3431 8.43359 31.7689 8.55469 32.0931L8.69531 32.4759H10.6602H12.625V33.0814V33.6869H10.9844C10.082 33.6869 9.34375 33.6986 9.34375 33.7103C9.34375 33.7533 9.80859 34.4095 10.0664 34.7338C11.8359 36.9408 14.625 38.1478 17.4883 37.9447C20.4141 37.7416 22.9609 36.3041 24.5234 33.972C24.8125 33.5424 25.2578 32.6634 25.4414 32.1634C25.6055 31.7103 25.8086 30.9095 25.8906 30.3666C25.9805 29.8041 25.9922 28.3744 25.9141 27.847C25.6523 26.1088 25.0742 24.6908 24.1133 23.433C23.8633 23.1049 23.1289 22.3549 22.7852 22.0775C21.457 21.0072 19.8359 20.3275 18.0937 20.1127C17.5 20.0424 16.3242 20.0424 15.75 20.1166Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1202_168",
    x: -8,
    y: -5,
    width: 51,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1202_168"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1202_168",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1202_168",
    x1: 33,
    y1: 22.997,
    x2: 0.00652899,
    y2: 22.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1202_168",
    x1: 33,
    y1: 22.9937,
    x2: 0.00652895,
    y2: 22.9937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B32079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5CB5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1202_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTab2);
export default __webpack_public_path__ + "static/media/feature_tab2.a2f28d3bb563fc76ad15a555f40199c4.svg";
export { ForwardRef as ReactComponent };